/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const djalban: CommunityData = {
  code: "djalban",
  name: "DJ Alban & Friends",
  thumbnail: "/assets/customizations/djAlban/djAlban-thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/dja-139`,
  socials: {
    instagramLink: "https://www.instagram.com/dj_alban_/",
    soundcloudLink: "https://soundcloud.com/albanhidri",
  },
  styles: {
    global: {
      counterColor: "#000000",
      alternativeLogo: {
        src: "/assets/customizations/djalban/logo-alt.png",
        styles: "w-[159px] object-contain",
      },
      logo: {
        src: "/assets/customizations/djalban/logo.png",
        styles: "w-[264px] h-[80px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#181816",
      asideStyles: "",
      asideBg: "#E0190B",
      contentBg: "#F1F1F1",
      contentBoxShadow: "shadow-[0px_4px_4px_rgba(0,0,0,0.25)]",
      bgDesktop: "/assets/customizations/djAlban/djAlban-bg.png",
      bgMobile: "/assets/customizations/djAlban/djAlban-bg.png",
      nonMemberBg: "/assets/customizations/djAlban/djAlban-bg.png",
      mainFont: "font-['ChakraPetch']",
      primaryButton:
        "w-full sm:w-fit !h-[53px] bg-[#201E1D] border-[2px] border-[#FF550C] !px-[30px] !text-base !leading-[1] font-bold !text-[#DDDDDD] rounded-[4px] whitespace-nowrap uppercase",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#FFEDE5",
      separator: "border-[#FF550C] border-t",
      item: "text-[18px] font-bold text-border-black tracking-[0.04em] leading-[18px] h-[40px] flex sm:justify-start justify-center items-center uppercase text-[#FFEDE5] !pt-1",
      itemSelected: "bg-[#D00E00] text-[#FFFFFF]",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles:
        "font-bold uppercase text-[#FF550C] text-border-black tracking-[0.04em] text-[28px] leading-7 pb-2",
      announcements: {
        customBg: "bg-[#FF550C]",
        lg: {
          title: "text-base sm:text-[28px] leading-[1] font-bold mb-1",
          subtitle: "text-[10px] leading-[11px] font-bold !text-black border border-black",
        },
        sm: {
          title: "text-base sm:text-[14px] leading-[1] font-bold mb-2",
          subtitle: "text-[10px] leading-[11px] font-bold !text-black border border-black",
        },
      },
      event: {
        title: "text-[14px] font-semibold leading-[18px] text-black",
        subtitle: "text-[14px] font-light leading-[18px] text-black",
      },
      shop: {
        title:
          "font-bold uppercase text-[#FF550C] text-border-black tracking-[0.04em] text-[28px] leading-6 ",
        text: "text-[14px] leading-[18px] text-black font-light",
        customShopImage: "/assets/customizations/djAlban/img_shop.png",
      },
    },
    announcements: {
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[57px]",
      header: "text-[32px] font-semibold leading-[32px] text-black",
      title: "text-[14px] font-semibold leading-[18px] text-black",
      description: "text-[14px] font-light leading-[18px] text-black",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[23px]",
      title: "text-[14px] font-semibold leading-[18px] text-black",
      description: "text-[14px] font-light leading-[18px] text-black",
      commentIconColor: "",
      likeIconColor: "",
    },
    event: {
      emptyOrLoadingState: "",
      sectionTitle:
        "font-bold uppercase text-[#FF550C] text-border-black tracking-[0.04em] text-[28px] leading-9",
      sectionSubtitle: "text-[14px] leading-[18px] font-semibold text-black",
      text: "text-[14px] leading-[18px] text-black font-light",
      separator: "border-b border-[#1F1F1F]",
      blockContainer: "",
      header: "",
      container: "",
      map: {
        pin: "",
        border: "",
        pinColor: "#FF550C",
        strokeColor: "border-[#1F1F1F]",
      },
    },
    eventTickets: {
      container: "",
      separator: "",
      event: {
        title:
          "font-bold text-border-black tracking-[0.04em] uppercase text-[#FF550C] text-[28px] leading-9",
        subtitle: "text-[14px] leading-[18px] font-semibold text-black",
      },
      ticket: {
        counterContainer: "",
        title:
          "text-[24px] text-border-black tracking-[0.04em] leading-[24px] font-bold text-[#FF550C] uppercase",
        description:
          "text-[16px] text-border-black tracking-[0.04em] leading-[16px] font-bold text-[#FF550C]",
        text: "text-[14px] leading-[18px] text-black",
        price: "text-[24px] text-border-black tracking-[0.04em] leading-6 font-bold text-[#FF550C]",
        quantity: "text-[16px] leading-5 font-bold font-bold",
      },
    },
  },
}

export default djalban
